import styled from "styled-components"
import OtpInput from "react-otp-input"
import { useEffect, useState } from "react"
import { MyUI } from "src/core/components"
import { useForceUpdate } from "src/modules/app_sigo/hooks/useForceUpdate"
import classNames from "classnames"
import { Button } from "reactstrap"
import { MdArrowBackIos, MdError } from "react-icons/md"
import { HCF, HUtils } from "@macashipo/mlib"

const ResendOTP = props => {
  const { showCountdown, fnSetShowCountdown, onResendOTP, dfResendTime } = props
  const [endtime, setEndTime] = useState(0)
  let _dfResendTime = 20
  if (dfResendTime) {
    _dfResendTime = dfResendTime
  }
  const [canResend, setCanResend] = useState(true)

  useEffect(() => {
    if (!canResend) {
      setCanResend(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCountdown])
  useEffect(() => {
    let time = getEndTime()
    setEndTime(time)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_dfResendTime, showCountdown])

  const getEndTime = () => {
    const date = new Date()
    date.setSeconds(date.getSeconds() + _dfResendTime)
    return date.getTime()
  }
  const disableResendOtp = () => {
    setCanResend(false)
  }

  return (
    <WrapResendOtp>
      {showCountdown ? (
        <div className="mb-15px note-resend">
          Gửi lại mã sau
          <MyUI
            type="countdown_time"
            endTime={endtime}
            moreConfig={{
              delay: 1,
              hideTitle: true,
              onlyShowSecond: true,
            }}
            fnList={{
              onFinishCountdown: () => {
                fnSetShowCountdown && fnSetShowCountdown(false)
              },
            }}
          />
        </div>
      ) : (
        <div className="wrapresend mb-15px">
          Bạn chưa nhận được tin nhắn SMS?{" "}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            className={classNames("resendotp", !canResend && "disabled")}
            href="#"
            onClick={e => {
              e.preventDefault()
              onResendOTP && onResendOTP({ disableResendOtp })
            }}
          >
            Gửi lại
          </a>
        </div>
      )}
    </WrapResendOtp>
  )
}
const InputOtp = props => {
  const { fnList, dfLoading } = props
  const [msg, setMsg] = useState("")
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState("")
  const [otpInputKey, forceUpdateOtpInput] = useForceUpdate()
  const dfConfigLogin = HUtils.get(HCF.getCF("websiteSetting"), "auth") || {}

  useEffect(() => {
    setLoading(dfLoading)
  }, [dfLoading])

  // Call API ngay khi nhập đủ otp
  useEffect(() => {
    if (
      dfConfigLogin?.auto_continue_when_otp_filled &&
      !getDisabledVerifyBtn()
    ) {
      onVerifyOTP()
    }
  }, [otp])

  const onVerifyOTP = () => {
    if (fnList && fnList?.onVerifyOTP) {
      setLoading(true)
      fnList?.setWrapLoading && fnList?.setWrapLoading(true)
      fnList.onVerifyOTP(otp, {
        cbSuccess: () => {
          setLoading(false)
          fnList?.setShowCountdown && fnList?.setShowCountdown(false)
          fnList?.setWrapLoading && fnList?.setWrapLoading(false)
        },
        cbError: msg => {
          setLoading(false)
          fnList?.setWrapLoading && fnList?.setWrapLoading(false) // for loading overlay
          if (msg) {
            setMsg(msg)
            // fnList?.setShowCountdown && fnList?.setShowCountdown(false)
            setOtp("") // clear data khi verify otp fail
            forceUpdateOtpInput() // focus lại ô đầu tiên để user nhập lại từ đầu khi verify thất bại
          }
        },
      })
    }
  }
  const getDisabledVerifyBtn = () => {
    if (loading || !otp || otp?.length < 6) {
      return true
    }
    return false
  }
  return (
    <>
      <div className={classNames("form-group otp-form", msg && "has-error")}>
        <OtpInput
          key={otpInputKey}
          onChange={v => {
            if (msg) {
              setMsg("")
            }
            setOtp(v)
          }}
          value={otp}
          numInputs={6}
          inputType={"number"}
          renderInput={props => (
            <input
              {...props}
              placeholder="-"
              className="text-center form-control form-control-solid itemotp"
              type="number"
              disabled={loading}
            />
          )}
          skipDefaultStyles={true}
          shouldAutoFocus={true}
        />
        {msg && (
          <Error className="__msgerr">
            <MdError />
            <MyUI type="html" html={msg} style={{ flex: 1 }} />
          </Error>
        )}
      </div>
      <Footer>
        <hr className="divider-line solid mb-25px"></hr>
        <div className="d-flex action">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          {/* <a
            className="btn-block"
            href="#"
            onClick={e => {
              e.preventDefault()
            }}
          >
            Phương thức khác
          </a> */}
          <MyUI
            type="sg_button"
            onClick={onVerifyOTP}
            color="primary-v2"
            className="btn-lg btn-block btnlogin"
            disabled={getDisabledVerifyBtn()}
            loading={loading}
            loadingColor={"#fff"}
            btnName="Tiếp tục"
          />
        </div>
      </Footer>
    </>
  )
}
const MyUIEnterOtp = props => {
  const { isActive, fnList, mobileNumber, dfResendTime } = props
  const [loading, setLoading] = useState(false)
  const [showCountdown, setShowCountdown] = useState(true)
  const [inputOtpKey, forceUpdateInputOtpKey] = useForceUpdate()
  const [keyResend, forceUpdateKeyResend] = useForceUpdate()

  useEffect(() => {
    // For autofocus otp input
    if (isActive) {
      setShowCountdown(true)
      forceUpdateInputOtpKey()
    } else {
      setShowCountdown(false)
      forceUpdateInputOtpKey()
    }
  }, [isActive])
  useEffect(() => {
    if (dfResendTime) {
      setShowCountdown(true)
    } else {
      setShowCountdown(false)
    }
  }, [dfResendTime])

  const getPhoneNumber4UI = () => {
    let text = mobileNumber
    if (fnList && fnList?.onFormatMobileNumber4UI) {
      text = fnList?.onFormatMobileNumber4UI(mobileNumber)
    }
    return text
  }

  const onResendOTP = ({ disableResendOtp }: any = {}) => {
    if (fnList && fnList?.onResendOTP) {
      setLoading(true)
      forceUpdateInputOtpKey() // reset lại value dfOtp của input Otp
      disableResendOtp && disableResendOtp()
      fnList.onResendOTP({
        cbSuccess: () => {
          setShowCountdown(true)
          setLoading(false)
        },
        cbError: () => {
          setShowCountdown(true)
          setLoading(false)
        },
      })
    }
  }
  const onGetDescriptionMsg = () => {
    if (fnList?.onGetDescription) {
      return fnList?.onGetDescription()
    }
    return ""
  }
  if (isActive) {
    return (
      <MyUI
        type="sg_loading_overlay"
        isLoading={loading}
        showLoadingIcon={false}
      >
        <Wrap
          className="tabdk mui-enter-otp"
          id="tabdkenterotp"
          style={{ display: isActive ? "block" : "none" }}
        >
          <div className="header">
            <Button
              color="hide-modal"
              onClick={() => {
                fnList?.onGoBack && fnList?.onGoBack()
              }}
            >
              <MdArrowBackIos />
            </Button>
            <div className="title">Xác nhận số điện thoại của bạn</div>
          </div>
          <div className="body">
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: onGetDescriptionMsg() }}
            ></div>
          </div>
          <InputOtp
            key={inputOtpKey}
            isActive={isActive}
            fnList={{
              ...fnList,
              setWrapLoading: setLoading,
              setShowCountdown: setShowCountdown,
            }}
            mobileNumber={mobileNumber}
            dfLoading={loading}
          />
          <div className="wrap-resend-opt">
            <ResendOTP
              key={keyResend}
              showCountdown={showCountdown}
              onResendOTP={onResendOTP}
              fnSetShowCountdown={setShowCountdown}
              dfResendTime={dfResendTime}
              loading={loading}
            />
          </div>
        </Wrap>
      </MyUI>
    )
  } else {
    return <></>
  }
}
const Error = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  color: var(--color-danger);
  font-size: 13px;
  margin: 5px 0 0;
  & > svg {
    margin-right: 0.25rem;
    margin-top: 5px;
    width: 15px;
    height: 15px;
  }
`
const WrapResendOtp = styled.div`
  position: absolute;
  top: -116px;
  color: var(--color-text-000);
  & .resendotp {
    text-decoration: underline;
    color: var(--color-text-000);
    font-weight: 700;
  }
`
const Footer = styled.div`
  margin-top: 70px;
  & .action {
    gap: 10px;
    align-items: center;
    a {
      text-decoration: underline;
      color: var(--color-text-000);
      font-weight: 700;
    }
    & .btn-black.disabled {
      background-color: #c9c9c9;
      opacity: 1;
    }
  }
`
const Wrap = styled.div`
  & .wrap-resend-opt {
    position: relative;
  }
  & .otp-form {
    padding: 0 25px;
    width: 100%;
    & > div:first-child {
      justify-content: center;
      border: 2px solid #959292;
      width: fit-content;
      padding: 10px 25px;
      border-radius: 8px;
      transition: border-color 0.15s ease;
    }
    &.has-error {
      & > div:first-child {
        border: 1px solid var(--color-danger);
      }
    }
    & .form-control.form-control-solid {
      background-color: #fff;
      border: none;
      color: #3f4254;
      box-shadow: none;
      border-radius: 0 !important;
      transition: color 0.15s ease, background-color 0.15s ease,
        border-color 0.15s ease, box-shadow 0.15s ease;
    }
    & .form-control {
      width: calc(100% / 6);
      height: 36px;
      padding: 0px;
      line-height: 40px;
      font-size: 30px;
      text-align: center;
      display: inline-block;
      margin-right: 20px;
    }
    & .form-control:last-child {
      margin-right: 0px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
  & .note-resend {
    display: flex;
    align-items: center;
    & .mui-countdown-time {
      margin-left: 3px;
      padding-top: 0;
      & .countdown {
        font-size: unset;
        line-height: unset;
      }
    }
  }
  & .resendotp.disabled {
    pointer-events: none;
    cursor: default;
  }
  & .description {
    color: var(--color-text-000);
    span {
      font-weight: 600;
    }
  }
  @media (max-width: 767px) {
    & .otp-form {
      padding: 0;
    }
  }
`
export default MyUIEnterOtp
